import { render, staticRenderFns } from "./FeedbackFormCard.vue?vue&type=template&id=62bbd042&"
import script from "./FeedbackFormCard.vue?vue&type=script&lang=js&"
export * from "./FeedbackFormCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports